var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B0A0A",
    fillRule: "nonzero",
    d: "M12 20h2.667v-2.667H12zm0-5.333h2.667v-8H12zm1.333 12C5.973 26.667 0 20.693 0 13.333S5.973 0 13.333 0s13.334 5.973 13.334 13.333-5.974 13.334-13.334 13.334m0-24c-5.88 0-10.666 4.786-10.666 10.666S7.453 24 13.333 24 24 19.213 24 13.333 19.213 2.667 13.333 2.667"
  })));
};
export default SvgAlertIcon;